import React from "react";
import PolicyPage from "./PolicyPage";

const TOC = [
  { id: "accounts",  label: "Accounts" },
  { id: "eligibility", label: "Eligibility" },
  { id: "content",   label: "Your content" },
  { id: "conduct",   label: "Conduct" },
  { id: "billing",   label: "Billing" },
  { id: "termination", label: "Termination" },
  { id: "warranty",  label: "Warranty" },
  { id: "law",       label: "Governing law" },
];

export default function Terms() {
  return (
    <PolicyPage
      testId="page-terms"
      path="/terms"
      title="Terms of Service | TalesTalesTales"
      description="The rules that apply when you use TalesTalesTales — account eligibility, content ownership, conduct, billing, and termination."
      eyebrow="Terms"
      h1="Terms of service"
      toc={TOC}
    >
      <p className="italic text-amber-100/60">
        These terms apply between you and TalesTalesTales when you use our website and services. By
        creating an account or using the free trial you agree to them.
      </p>

      <section id="accounts">
        <h2 className="font-display text-2xl text-amber-50 mt-6 mb-3">Accounts</h2>
        <p>
          You must provide accurate account details and keep your credentials secure. One person per
          account; sharing accounts is not permitted. You are responsible for activity that happens
          under your account.
        </p>
      </section>

      <section id="eligibility">
        <h2 className="font-display text-2xl text-amber-50 mt-6 mb-3">Eligibility</h2>
        <p>
          You must be at least 13 years old (or the age of digital consent in your jurisdiction) to
          register. Mature Realms and any 18+ features are strictly limited to age-verified adult
          subscribers.
        </p>
      </section>

      <section id="content">
        <h2 className="font-display text-2xl text-amber-50 mt-6 mb-3">Your content</h2>
        <p>
          You retain ownership of the sagas and custom worlds you create. You grant TalesTalesTales a
          limited licence to store, process and display your content to render the game and, where
          you have opted in, to display community-published worlds.
        </p>
        <p>
          The copyright status of AI-generated text and images is unsettled in many jurisdictions.
          Treat AI-drafted prose as you would any collaborator&rsquo;s contribution.
        </p>
      </section>

      <section id="conduct">
        <h2 className="font-display text-2xl text-amber-50 mt-6 mb-3">Conduct</h2>
        <p>See the <a href="/content-policy" className="underline hover:text-amber-100">Content Policy</a> for the full list.</p>
        <p>Prohibited use includes but is not limited to:</p>
        <ul className="list-disc pl-5 space-y-1">
          <li>Generating sexual content involving minors.</li>
          <li>Depicting real, identifiable people in sexual scenarios.</li>
          <li>Reverse-engineering, scraping, or abusing our APIs.</li>
          <li>Harassment or targeted attacks on other users or staff.</li>
        </ul>
      </section>

      <section id="billing">
        <h2 className="font-display text-2xl text-amber-50 mt-6 mb-3">Billing</h2>
        <p>
          Paid tiers renew monthly via Stripe. You can cancel at any time from your Profile page.
          Cancellation stops the next renewal; the current period runs out. We do not offer
          pro-rated refunds for partial months except where required by law.
        </p>
      </section>

      <section id="termination">
        <h2 className="font-display text-2xl text-amber-50 mt-6 mb-3">Termination</h2>
        <p>
          We may suspend or terminate accounts that violate these terms or the Content Policy. You
          can delete your account any time from Profile → Danger zone. See the Privacy policy for
          data retention on deletion.
        </p>
      </section>

      <section id="warranty">
        <h2 className="font-display text-2xl text-amber-50 mt-6 mb-3">Warranty & liability</h2>
        <p>
          The service is provided &ldquo;as is&rdquo;. AI-generated content may be inaccurate,
          inconsistent or unexpected. To the fullest extent permitted by law, we disclaim implied
          warranties of merchantability, fitness for a particular purpose, and non-infringement.
          Our aggregate liability is limited to the fees you paid us in the previous 12 months.
        </p>
      </section>

      <section id="law">
        <h2 className="font-display text-2xl text-amber-50 mt-6 mb-3">Governing law</h2>
        <p>
          These terms are governed by the laws of the United States. Disputes will be resolved in
          the courts of competent jurisdiction. If any clause is unenforceable, the rest still
          applies.
        </p>
      </section>
    </PolicyPage>
  );
}
